import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Translator } from "@sharedV11/services/translator/translator.service";

@Component({
  selector: "app-input-filter",
  templateUrl: "./input-filter.component.html",
  styleUrls: ["./input-filter.component.scss"],
})
export class InputFilterComponent implements OnInit, OnChanges {
  @Input() formControlText: any;
  @Input() placeHolderTranslation: string;
  @Input() label: string;
  @Input() list: any[] = [];
  // text show in input
  @Input() textShow: any;
  //data input
  @Input() dataInput: any;

  //API data
  @Input() data: any;
  @Input() required: any;
  @Input() disabled: any;
  // Quando true (default), o componente marca todos os campos como "touched"
  // ao iniciar, mostrando imediatamente erros de obrigatório.
  // Para cenários em que o aviso deve aparecer apenas após tentar guardar,
  // defina [autoValidate]=\"false\".
  @Input() autoValidate: boolean = true;

  @Output() close = new EventEmitter();
  @Output() selected = new EventEmitter();
  @Output() getMethods = new EventEmitter();
  @Output() emitTextValueWithValue = new EventEmitter();

  listCopy: any[];
  idList;
  editorRegistroForm: FormGroup;

  intervalId;
  translation: any;

  constructor(
    private formBuilder: FormBuilder,
    private _cds: ChangeDetectorRef,
    private translator: Translator,
  ) {}
  ngAfterViewInit() {
    if (document.getElementById(this.formControlText)) {
      document
        .getElementById(this.formControlText)
        .setAttribute("list", this.idList);
    }
    // this.addEvent();
    this.showData();
    this.controlErrors();
  }
  
  async ngOnInit() {
    this.translation = this.translator.GetTranslations();
    this.initlist();
  }

ngOnChanges(changes: SimpleChanges) {
  if (!this.editorRegistroForm) return;

  // Lista pode chegar depois (async). Precisamos atualizar listCopy/datalist
  // e garantir que o texto exibido reflita o `data` atual.
  if (changes["list"] && !changes["list"].firstChange) {
    this.initlist(changes["list"].currentValue);
    setTimeout(() => this.showData(), 0);
  }

  // Quando o valor vindo de fora (data) muda, sincronizamos o texto exibido.
  if (changes["data"] && !changes["data"].firstChange) {
    const next = changes["data"].currentValue;
    const shouldClear =
      next === null ||
      next === undefined ||
      next === "" ||
      next === "-1" ||
      next === 0 ||
      next === "0";

    if (shouldClear) {
      this.data = next;
      this.editorRegistroForm.controls["answer"].setValue("");
      this.editorRegistroForm.controls["answerHidden"].setValue(
        next === "-1" ? "-1" : ""
      );
      this._cds.detectChanges();
    } else {
      setTimeout(() => this.showData(), 0);
    }
  }

    // Quando autoValidate muda de false -> true depois da inicialização,
    // reaplicamos a validação para mostrar/ocultar os erros conforme necessário.
    if (changes["autoValidate"] && !changes["autoValidate"].firstChange) {
      if (this.editorRegistroForm) {
        this.controlErrors();
      }
    }
    // Reagir a mudanças no required (ex: validação condicional de Complementos)
    if (changes['required'] && this.editorRegistroForm) {
      const answerCtrl = this.editorRegistroForm.get('answer');
      if (answerCtrl) {
        const hasRequired = this.required === 'true' || this.required === true;
        answerCtrl.setValidators(hasRequired ? [Validators.required] : []);
        answerCtrl.updateValueAndValidity({ emitEvent: false });
      }
    }
  }

  OnChange() {
    if (this.listCopy && this.listCopy.length > 0) {
      let valName = (<HTMLInputElement>(
        document.getElementById(this.formControlText)
      )).value;
      //let val= (<HTMLInputElement>document.getElementById(this.formControlText+"-hidden")).value
      let val = this.editorRegistroForm.get("answerHidden").value;
      let find = this.listCopy.find(
        (find) =>
          find[this.textShow].trim().replace("  ", " ") ==
          valName.trim().replace("  ", " ")
      );

      if (!find) {
        if (valName.length) {
          this.editorRegistroForm.controls["answerHidden"].setValue('-1');
        } else {
          this.editorRegistroForm.controls["answerHidden"].setValue('');
        }

        this.editorRegistroForm.controls["answer"].setErrors(null);
      } else {
        let valueFind = find[this.dataInput];

        this.editorRegistroForm.get("answerHidden").setValue(valueFind);
        this.editorRegistroForm.controls["answer"].setErrors(null);
      }
      val = this.editorRegistroForm.get("answerHidden").value;

      this.emitTextValueWithValue.emit({name: valName, value: val })
      // Só emite selected quando há seleção válida ou quando o campo está vazio.
      // Evita emitir -1 durante a digitação, o que faria o seletor desaparecer.
      if (find || valName.length === 0) {
        this.selected.emit({ name: this.formControlText, value: val, methods: this.callbackMethods() });
      }
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
      this.selected.emit({ name: this.formControlText, value: "-1", methods: this.callbackMethods() });
    }
  }

  initlist(list?) {
    if (list) this.list = list;
    this.listCopy = Array.isArray(this.list) ? [...this.list] : [];
    this.idList = this.formControlText + "-list";
    //document.getElementById(this.formControlText).setAttribute("list", this.idList)
    this.generateForm();
  }

  controlErrors() {
    if (this.autoValidate) {
      this.editorRegistroForm.markAllAsTouched();
      this.editorRegistroForm.updateValueAndValidity();
    }
    this._cds.detectChanges();
  }

  callbackMethods() {
    return {
      markFormAsInvalid: this.markFormAsInvalid.bind(this),
      manualOnchange: this.OnChange.bind(this),
      setManualValueForm: this.setManualValueForm.bind(this),
      showData: this.showData.bind(this),
      toggleActiveForm: this.toggleActiveForm.bind(this),
    }
  }

  markFormAsInvalid(control: string, errors: any) {
    this.editorRegistroForm.controls[control].setErrors(errors);
  }

  toggleActiveForm(active = true) {
    if (active) {
      this.editorRegistroForm.enable();
    } else {
      this.editorRegistroForm.disable();
    }
    this.disabled = !active;
  }

  showData() {
    if (this.disabled) {
      this.editorRegistroForm.get("answer").disable();
    }
    // Aceitar valores "0" como válidos (não tratar como vazio)
    // Verificar se data não é null/undefined/vazio string, mas aceitar "0"
    if (
      this.data !== null && 
      this.data !== undefined && 
      this.data !== '' &&
      this.listCopy &&
      this.listCopy.length > 0
    ) {
      // Converter para string para comparação consistente
      const dataValue = String(this.data);
      let value = this.listCopy.find(
        (find) => String(find[this.dataInput]) == dataValue
      );
      if (value) {
        value = value[this.textShow];
        //(<HTMLInputElement>document.getElementById(this.formControlText)).value = value
        this.editorRegistroForm.controls["answer"].setValue(value);
      }
      this.editorRegistroForm.controls["answerHidden"].setValue(dataValue);
    }
    this._cds.detectChanges();
  }

  setManualValueForm(value) {

    let value_ = value ? value : "";

    if (value) {
      let find = this.listCopy.find(
        (find) => find[this.dataInput] == value
      );
      if (find) {
        value_ = find[this.textShow];
      }
    }
    this.data = value;
    this.editorRegistroForm.controls["answer"].setValue(value_);
    this.editorRegistroForm.controls["answerHidden"].setValue(value);
  }

  generateForm() {
    this.editorRegistroForm = this.formBuilder.group({
      answer: [
        { value: "", disabled: this.disabled },
        this.required == "true" ? [Validators.required] : [],
      ],
      // answer:["",[Validators.required]],
      answerHidden: [""],
    });

    this.getMethods.emit({ methods: this.callbackMethods() });
  }

  intervaloClose() {
    /* if(this.interval){
      clearInterval(this.interval)
    } */
    let thisobj = this;

    setTimeout(function () {
      thisobj.closeInput();
    }, 1000);
    //clearInterval(this.intervalId)
  }
  closeInput() {
    clearInterval(this.intervalId)
    if (this.listCopy && this.listCopy.length > 0) {
      let valName = (<HTMLInputElement>(
        document.getElementById(this.formControlText)
      )).value;
      //let val= (<HTMLInputElement>document.getElementById(this.formControlText+"-hidden")).value
      let val = this.editorRegistroForm.get("answerHidden").value;
      let find = this.listCopy.find(
        (find) =>
          find[this.textShow].trim().replace("  ", " ") ==
          valName.trim().replace("  ", " ")
      );

      if (!find) {
        if (valName.length) {
          this.editorRegistroForm.controls["answerHidden"].setValue('-1');
        } else {
          this.editorRegistroForm.controls["answerHidden"].setValue('');
        }
        this.editorRegistroForm.controls["answer"].setErrors(null);
      } else {
        let valueFind = find[this.dataInput];

        this.editorRegistroForm.get("answerHidden").setValue(valueFind);
        this.editorRegistroForm.controls["answer"].setErrors(null);
      }
      val = this.editorRegistroForm.get("answerHidden").value;

      this.emitTextValueWithValue.emit({name: valName, value: val })
      this.close.emit({ name: this.formControlText, value: val, methods: this.callbackMethods() });
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
      this.close.emit({ name: this.formControlText, value: "-1", methods: this.callbackMethods() });
    }
  }

  addEvent() {
    let thisobj = this;
    document.querySelectorAll("input[list]").forEach((hElement) => {
      hElement.addEventListener("input", function (e) {
        var input = e.target as HTMLTextAreaElement,
          listCopy = input.getAttribute("list"),
          options: any = Array.from(
            document.querySelectorAll("#" + listCopy + " option")
          ),
          hiddenInput = <HTMLInputElement>(
            document.getElementById(input.getAttribute("id") + "-hidden")
          ),
          label = input.value;

        hiddenInput.nodeValue = label;
        let find = thisobj.findOption(label);
        if (find) {
          hiddenInput.value = find[thisobj.dataInput];
          thisobj.editorRegistroForm
            .get("answerHidden")
            .setValue(find[thisobj.dataInput]);
        }
        // thisobj.closeInput();
        /* for(var i = 0; i < options.length; i++) {
            var option = options[i];
            option.innerHTML = option.innerHTML.trim()
            if(option.innerHTML == label) {
              hiddenInput.value = option.getAttribute('title');
                break;
            }
        } */
      });
    });
  }

  get f() {
    return this.editorRegistroForm.controls;
  }

  selectString(str) {
    if (this.listCopy && this.listCopy.length > 0) {
      let valName = str;
      let val = this.editorRegistroForm.get("answerHidden").value;

      let find = this.listCopy.find(
        (find) =>
          find[this.textShow].trim().replace("  ", " ") ==
          valName.trim().replace("  ", " ")
      );

      if (!find) {
        this.editorRegistroForm.controls["answerHidden"].setValue("");
        if (this.editorRegistroForm.controls["answer"].value.trim() != "") {
          this.editorRegistroForm.controls["answer"].setErrors({
            incorrect: true,
          });
        }
        //this.editorRegistroForm.controls["answer"].updateValueAndValidity()
        //(<HTMLInputElement>document.getElementById(this.formControlText)).innerHTML=""
      } else {
        let valueFind = find[this.dataInput];

        this.editorRegistroForm.controls["answer"].setValue(
          find[this.textShow]
        );
        this.editorRegistroForm.get("answerHidden").setValue(valueFind);

        /*  if(this.editorRegistroForm.controls["answer"].value.trim()!=""){
          this.editorRegistroForm.controls["answer"].setErrors(null);
        } */
        this.editorRegistroForm.controls["answer"].setErrors(null);
        //this.editorRegistroForm.controls["answerHidden"].setValue(val);
        this.selected.emit(true);
      }
      val = this.editorRegistroForm.get("answerHidden").value;

      this.close.emit({ name: this.formControlText, value: val, methods: this.callbackMethods() });
    } else {
      this.editorRegistroForm.controls["answerHidden"].setValue("");
      this.close.emit({ name: this.formControlText, value: "-1", methods: this.callbackMethods() });
    }
  }

  findOption(label) {
    let find = this.listCopy.find(
      (find) =>
        find[this.textShow].trim().replace("  ", " ") ==
        label.trim().replace("  ", " ")
    );

    return find;
  }
}
